import React from 'react';
import { Route, Redirect } from 'react-router';

import AdminLayout from './adminLayout';

const AdminLayoutRoute = ({ component: Component, ...rest }) => {
    return (
        <Route {...rest} render={matchProps => (
            localStorage.getItem('user')
                ? <AdminLayout> <Component {...matchProps} /> </AdminLayout>
                : <Redirect to={{ pathname: '/login', state: { from: matchProps.location } }} />
        )} />
    )
};

export default AdminLayoutRoute;





// WEBPACK FOOTER //
// ./src/components/admin/adminLayoutRoute.js